var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSheets = function SvgSheets(props) {
  return React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24
  }, props), _path || (_path = React.createElement("path", {
    d: "M232-172q-26 0-43-17t-17-43v-496q0-26 17-43t43-17h496q26 0 43 17t17 43v496q0 26-17 43t-43 17H232zm234-219H200v159q0 14 9 23t23 9h234v-191zm28 0v191h234q14 0 23-9t9-23v-159H494zm-28-28v-193H200v193h266zm28 0h266v-193H494v193zM200-640h560v-88q0-14-9-23t-23-9H232q-14 0-23 9t-9 23v88z"
  })));
};
export default __webpack_public_path__ + "51a11be6983266b6147fe74713299687.svg";
export { SvgSheets as ReactComponent };